import PropTypes from 'prop-types'
import React from 'react'
import { Header } from '../../Header'
import { connect } from 'react-redux'
import { getUserInfo } from '../../../../../selectors'
import { PhotoLoader } from '../PhotoLoader'

export const Container = ({photoLimit}) =>
  photoLimit > 0
    ? [
      <Header key='header'>{`Fotografije (max ${photoLimit})`}</Header>,
      <PhotoLoader key='photoLoader' />
    ]
    : null

const mapStateToProps = state => {
  const userInfo = getUserInfo(state)
  let photoLimit = 0
  if (userInfo.packages && Array.isArray(userInfo.packages) && userInfo.packages.length) {
    photoLimit = Number(userInfo.packages[0].photoLimit)
  }
  return {
    photoLimit
  }
}

Container.displayName = 'Photos'

Container.propTypes = {
  photoLimit: PropTypes.number.isRequired
}

Container.defaultProps = {
  photoLimit: 0
}

export default connect(mapStateToProps)(Container)
